var map = {
	"./de-DE/common": 85468,
	"./de-DE/common.json": 85468,
	"./de-DE/seo": 26197,
	"./de-DE/seo.json": 26197,
	"./de-DE/unit": 68337,
	"./de-DE/unit.json": 68337,
	"./en/common": 1807,
	"./en/common.json": 1807,
	"./en/seo": 63351,
	"./en/seo.json": 63351,
	"./en/unit": 3891,
	"./en/unit.json": 3891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57478;